import { IPlayerState } from '../reducer.types';
import { COMPONENT_NAME as PLAYER_NAMESPACE } from '../constants';
import { getNextAvailableTrackIdInPlaylist } from '../selectors';

export const trackEndReducer = (state: IPlayerState) => ({
  ...state,
  // I want to reuse selector, but that is working with global redux state and
  // here I have access only local Player redux state -> I am faking it here
  currentlyPlayingTrackId: getNextAvailableTrackIdInPlaylist({
    [PLAYER_NAMESPACE]: state,
  }),
});
